<section class="tender-support-card">
  <div class="tender-support-card__icon-wrap">
    <i class="iconsax tender-support-card__icon" icon-name="headphones"></i>
  </div>

  <div class="tender-support-card__content">
    <h3 class="tender-support-card__title">
      {{ 'tenders.rfpAdviceQuestion' | translate }}
    </h3>
    <p class="tender-support-card__subtitle">
      {{ 'tenders.helpdeskAvailable247' | translate }}
    </p>
  </div>

  <a [href]="contactLink" target="_blank" rel="noopener noreferrer">
    <pwj-button variant="primary" size="medium">
      {{ 'tenders.contactOfficer' | translate }}
    </pwj-button>
  </a>
</section>
